export default function generateRandomString(length) {
  if (!length) {
    length = 5;
  }
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let randomString = "";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength);
    randomString += characters.charAt(randomIndex);
  }

  return randomString;
}
